var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.role)?_c('span',{staticClass:"tag tag-role",class:{ 'tag-owner': _vm.isAdmin, dark: _vm.dark }},[_vm._v(" "+_vm._s(_vm.$t(`members.roles.labels.${ _vm.role }`))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }